<div
  class="card-doctor bg-white rounded-xl p-4 grid grid-cols-1 gap-4 md:grid-cols-3 lg:grid-cols-6 md:gap-6 md:min-h-[220px] items-stretch">
  <!-- Doctor Info -->
  <div class="flex flex-col gap-2 md:col-span-1 lg:col-span-1 justify-top">
    <div class="flex items-top gap-x-3">
      <!-- Avatar -->
      <div class="w-12 h-12 rounded-full bg-slate-200 flex items-center justify-center flex-shrink-0">
        @if (doctor.avatar) {
        <img [src]="doctor.avatar" [alt]="doctor.firstname" class="w-full h-full object-cover rounded-full" />
        } @else {
        <lucide-icon [img]="UserIcon" color="gray" [size]="21"></lucide-icon>
        }
      </div>
      <!-- Name, specialisation, address, button in column -->
      <div class="flex flex-col">
        <h5 class="!font-medium text-gray-600">
          {{ doctor.title.name }} {{ doctor.firstname }}
          {{ doctor.lastname }}
        </h5>
        @if (doctor.specialisations && doctor.specialisations.length > 0) {
        <p class="text-primary text-sm">
          @for (spec of doctor.specialisations.slice(0, 3); track $index; let last = $last)
          {
          {{ spec }}@if (!last) {, } }
        </p>
        } @if (doctor.coordonate.globalAddressField) {
        <div>
          <p class="text-gray-500 text-sm">
            {{ doctor.coordonate.globalAddressField }}
          </p>
          @if (doctor.distance != null) {
          <span class="flex items-center gap-x-1 text-xs text-gray-400 mt-1">
            <lucide-icon class="text-primary" [img]="MapPinIcon" [size]="14"></lucide-icon>
            <span class="text-primary">{{
              roundDistance(doctor.distance)
              }}</span>
          </span>
          }
        </div>
        }
        <button [routerLink]="[PrefixUrlCountryCode, 'medecins', doctor.id]"
          class="btn btn-sm w-fit bg-[#232c7c] text-white rounded-full text-sm hover:bg-[#232c7c]-dark transition-colors mt-2">
          <span class="flex-none flex items-center gap-x-2"> Voir les détails </span>
        </button>
      </div>
    </div>
  </div>

  <!-- Availability or slots (visible dès md pour debug; remettre hidden lg:flex si besoin) -->
  <div class="hidden sm:flex items-center justify-center md:col-span-2 lg:col-span-3 min-h-32">
    <div class="grow py-2 w-full">
      <app-doctor-structure-slots [doctor]="doctor"></app-doctor-structure-slots>
    </div>
  </div>

  <div class="flex-grow min-w-[450px] hidden lg:block">
    <app-safe-maps [latitude]="doctor.coordonate.latitude ?? 0" [longitude]="doctor.coordonate.longitude ?? 0"
      [zoom]="15" height="100px">
    </app-safe-maps>
  </div>
</div>